// src/modules/app-views/ticket-events/pages/Init/actions/actionButton.js

import { PlusOutlined } from '@ant-design/icons';
import useZustand from 'hooks/useZustand';

const ticketEventsInitActionButton = () => {
  return {
    action: 'new',
    hideButton: false,
    label: 'new',
    tooltip: 'new_ticket_event',
    icon: <PlusOutlined />,
    type: 'primary',
    disabled: false,

    onClick: ({ navigate, setPage }) => {
      const setLoadingPageStore = useZustand('boot', 'setLoadingPage', false);
      setLoadingPageStore({ visible: true, extendedDelayToHide: 600 });

      setPage({
        navigate,
        pageName: 'document',
        params: { _id: 'add' },
      });
    },

    dropdownItems: [],
  };
};

export default ticketEventsInitActionButton;
